import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import http from '@/$plugins/http'

import base from '../base'
import ENTITY from '../base/entity'
import IS from '../base/is'

export default {
  namespaced: true,
  state: base.createState(IS.state, ENTITY.state, {
    byEndUserId: {}
  }),
  getters: base.createGetters(IS.getters, ENTITY.getters, {
    getUnwrappedByEndUserId: (state, getters) => endUserId => {
      const ids = state.byEndUserId[endUserId] || []
      return ids
        .map(id => getters.getEntityUnwrapped(id))
        .filter(Boolean)
    }
  }),
  mutations: base.createMutations(IS.mutations, ENTITY.mutations, {
    setByEndUserId (state, { endUserId, endUserTenantLoginIds }) {
      state.byEndUserId = Object.assign({}, state.byEndUserId, { [endUserId]: endUserTenantLoginIds })
    }
  }),
  actions: base.createEntityActions(STOREMODULE_ENDPOINTMODULE_MAP.customer, STOREMODULE_ENDPOINT_MAP.endusertenantlogin, IS.actions, ENTITY.actions, {
    getByEndUser (serverModuleName = '', serverEntityName = '', entityKey = '') {
      return function ({ state, getters, commit, dispatch }, endUserId = '') {
        commit('setLoading', { key: 'getByEndUser', loading: true, initial: true })

        return new Promise(resolve => {
          http({
            method: 'get',
            url: `/${serverModuleName}/api/${serverEntityName}/fromenduser/${endUserId}`
          })
            .then(response => {
              // API returns a single object, but set mutation expects an array
              const entities = Array.isArray(response.data.result) ? response.data.result : [response.data.result]
              const ids = entities
                .filter(Boolean)
                .map(e => e.id)

              // Keep entity store updated
              entities.forEach(e => {
                if (e) commit('setEntity', { key: entityKey, entity: e })
              })

              commit('setByEndUserId', { endUserId, endUserTenantLoginIds: ids })
              resolve(getters.getUnwrappedByEndUserId(endUserId))
            })
            .finally(() => {
              commit('setLoading', { key: 'getByEndUser', loading: false })
            })
        })
      }
    },
    triggerPasswordreset (serverModuleName = '', serverEntityName = '', entityKey = '') {
      return function ({ state, getters, commit, dispatch }, endUserTenantLoginId = '') {
        commit('setSending', { key: 'triggerPasswordreset', sending: true })

        return new Promise(resolve => {
          http({
            method: 'put',
            url: `/${serverModuleName}/api/${entityKey}/${endUserTenantLoginId}/resetpassword`
          })
            .then(response => {
              commit('setEntity', { key: entityKey, entity: response.data.result.value })
              resolve(getters.getEntity(response.data.result.value.id))
            })
            .finally(() => {
              commit('setLoading', { key: 'triggerPasswordreset', loading: false })
            })
        })
      }
    },
    triggerEmailConfirmation (serverModuleName = '', serverEntityName = '', entityKey = '') {
      return function ({ state, getters, commit, dispatch }, endUserTenantLoginId = '') {
        commit('setSending', { key: 'triggerEmailConfirmation', sending: true })

        return new Promise(resolve => {
          http({
            method: 'put',
            url: `/${serverModuleName}/api/${entityKey}/${endUserTenantLoginId}/setemailconfirmed`
          })
            .then(response => {
              commit('setEntity', { key: entityKey, entity: response.data.result.value })
              resolve(getters.getEntity(response.data.result.value.id))
            })
            .finally(() => {
              commit('setLoading', { key: 'triggerEmailConfirmation', loading: false })
            })
        })
      }
    },
    triggerResetLockout (serverModuleName = '', serverEntityName = '', entityKey = '') {
      return function ({ state, getters, commit, dispatch }, endUserTenantLoginId = '') {
        commit('setSending', { key: 'triggerResetLockout', sending: true })

        return new Promise(resolve => {
          http({
            method: 'put',
            url: `/${serverModuleName}/api/${entityKey}/${endUserTenantLoginId}/resetlockout`
          })
            .then(response => {
              commit('setEntity', { key: entityKey, entity: response.data.result.value })
              resolve(getters.getEntity(response.data.result.value.id))
            })
            .finally(() => {
              commit('setLoading', { key: 'triggerResetLockout', loading: false })
            })
        })
      }
    }
  })
}

